import { render, staticRenderFns } from "./purchase-order-edit-modal.vue?vue&type=template&id=b21b101a&scoped=true"
import script from "./purchase-order-edit-modal.vue?vue&type=script&lang=js"
export * from "./purchase-order-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./purchase-order-edit-modal.vue?vue&type=style&index=0&id=b21b101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21b101a",
  null
  
)

export default component.exports